

























import { Component, Vue } from 'vue-property-decorator'
import { MessageBox, Message } from 'element-ui'
import BlockTitle from '@/components/common/BlockTitle.vue'
import $Api from '@api'
import { BlacklistPushItem, BlacklistConfigUpdateRequest } from '@/api/model/blacklist'
import { finalize } from 'rxjs/operators'
import { translate } from '@/utils/filters'

@Component({
    components: {
        BlockTitle
    }
})
export default class Blacklist extends Vue {
    loading: boolean = false
    pushItems: BlacklistPushItem[] = []
    overdueDays: number | null = null

    checkList: number[] = []

    created(): void {
        this.getData()
    }
    getData(): void {
        this.loading = true
        $Api.blacklistService
            .query()
            .pipe(
                finalize(async () => {
                    await new Promise((resolve) => setTimeout(resolve, 300))
                    this.loading = false
                })
            )
            .subscribe(res => {
                const checkList: number[] = []
                this.pushItems = res.items
                this.overdueDays = res.overdueDays
            })
    }
    updateConfigSubmit(): void {
        const itemValues = this.checkList.join(',')
        const overdueDays = this.overdueDays
        if (overdueDays) {
            const valid = this.validOverdueDays(+overdueDays)
            if (!valid) {
                return
            }
        }
        let params: BlacklistConfigUpdateRequest = {
            itemValues: itemValues,
            overdueDays: overdueDays
        }
        MessageBox.confirm(
            translate('common.edit.message'),
            translate('common.tip'),
            {
                confirmButtonText: translate('common.btn.confirm'),
                cancelButtonText: translate('common.btn.cancel')
            }
        )
            .then(() => {
                $Api.blacklistService.update(params).subscribe(
                    res => {
                        this.getData()
                        this.$message({
                            message: translate('common.success'),
                            type: 'success'
                        })
                    },
                    err => {
                        this.$notify.error(err)
                    }
                )
            })
            .catch(() => {})
    }

    validOverdueDays(overdueDays: number): boolean {
        const isNumber = isNaN(overdueDays) === true
        const isNumberErroeMessage = translate('repayment.unpaid.partialDialog.calcPartRepaymentHandler.notNumber') as string

        if (this.validator(isNumber, isNumberErroeMessage)) {
            return false
        }

        return true
    }

    validator(bool: boolean, message?: string, type?: string): boolean {
        if (bool) {
            Message[type || 'error'](message as string)
            return true
        } else {
            return false
        }
    }
}
